module.exports = __webpack_public_path__ + "static/media/lineage.84c79f24.jpg";